
import type { DropTargetMonitor } from 'react-dnd';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import EDBox from '../EDBox/EDBox';
import EDIcon from '../Icon/EDIcon';
import SelectFileButton from '../SelectFileButton/SelectFileButton';
import EDTypography from '../Typography/EDTypography';

export interface IProps {
  setFiles: (files: FileList | null) => void;
}

export const FileDropTarget: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { setFiles } = props;
  const [_, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item: { files: FileList }) {
        setFiles(item.files);
      },
      canDrop(item: any) {
        return true;
      },
      hover(item: any) {},
      collect: (monitor: DropTargetMonitor) => {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [props]
  );

  return (
    <EDBox
      //React-dnd är inte uppdaterat för nyare versioner av React, så vi får ignorera ref-typen här
      ref={drop as any}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
        textAlign: 'center',
        backgroundColor: theme => theme.palette.grey[100],
        border: theme => `3px dashed ${theme.palette.grey[500]}`,
      }}
    >
      <EDIcon iconType={'cloud_upload'} size="extraLarge" color={'disabled'} />
      <EDTypography>Dra filer hit</EDTypography>
      <EDTypography>eller</EDTypography>
      <SelectFileButton setFiles={props.setFiles} hideButtonIcon />
    </EDBox>
  );
};
